<template>
  <div v-if="canShowSendButton">
    <v-btn v-if="!value" :loading="sendMessageLoading" @click="buttonAction()">
      <v-icon class="mr-2">mail</v-icon> Send Emails
    </v-btn>
    <div v-else>
      Campagne email envoyée le {{ dateFormatted }}
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, defineProps, defineEmits } from 'vue';
import gql from 'graphql-tag';
import { useMutation } from '@vue/apollo-composable';
import { useStore } from 'vue2-helpers/vuex';
import moment from 'moment';
import { EventBus } from '../../../mixins';

const store = useStore();
const emit = defineEmits(['input']);
const props = defineProps({
  value: {
    type: Number,
    default: null
  },
  field: {
    type: Object,
    default: () => null
  },
  formContent: {
    type: Object,
    default: () => null
  }
});

const dateFormatted = computed(() => {
  if (!props.value) return null;
  return moment(props.value).format('DD/MM/YYYY à HH:mm');
});

const uuid = computed(() => props.formContent?.uuid);

const emailsSent = ref(false);

const canShowSendButton = computed(() => props.formContent?.online && props.formContent?.status === 'published');

const { mutate: sendEmails, loading: sendMessageLoading } = useMutation(
  gql`
    mutation alphaSendPromotionalCampaignsEmails($uuid: String!, $workspace: String!) {
      alphaSendPromotionalCampaignsEmails(uuid: $uuid, workspace: $workspace) {
        success
        data
        message
      }
    }
  `,
  () => ({
    variables:
    {
      uuid: uuid.value,
      workspace: store.getters.workspace.code
    }
  })
);

const buttonAction = async () => {
  emailsSent.value = await sendEmails().then(res => {
    if (res.data.alphaSendPromotionalCampaignsEmails.success) {
      const text = 'Emails sent successfully';
      const options = {
        timeout: 5000,
        type: 'success'
      };
      console.log('Emails sent successfully');
      EventBus.$emit('show-notification', { text, options });
      return res.data.alphaSendPromotionalCampaignsEmails.data.emailsSentTimestamp;
    }

    const text = 'Error sending emails';
    const options = {
      timeout: 5000,
      type: 'error'
    };

    EventBus.$emit('show-notification', { text, options });
    return null;
  });
};

// const uuid = computed(() => props.uuid);

watch(emailsSent, () => {
  emit('input', emailsSent.value);
});
</script>
